<template>
  <div class="medical-alert-user-container pl-1 gap">
    <span>by</span>
    <Icon :icon="icon" :color="color"/>
  </div>
</template>

<script setup lang="ts">
import Icon from "@/components/Icons/Icon.vue";
import {defineProps} from 'vue';

defineProps({
  icon: {
    type: String,
    default: 'client-icon'
  },
  color: {
    type: String,
    default: 'primaryColor'
  },
  gap: {
    type: String,
    default: '4px'
  }
});
</script>

<style scoped lang="scss">
.medical-alert-user-container {
  font-size: 10px;
  font-weight: 400;
  line-height: 18px;
  display: flex;
  align-items: center;
}

.gap {
  gap: v-bind(gap);
}
</style>